import { render } from "./TheHeader.vue?vue&type=template&id=7dd3b89e&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=7dd3b89e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd3b89e"]])

export default __exports__